module.exports = __webpack_public_path__ + "static/media/david's place.68902039.jpeg";